export var SENTRY_RELEASE = "6c837a5b5a38a79477b6462320c66b365639cad6";
